import { useWizard } from "react-use-wizard";
import buySteps from "../buySteps";
import { TBooleanKeysOfIFillDataWizardBuy, TKeyOfDataWizardBuy } from "../..";
import FinanceStep from "../../../../../../shared/wizard/steps/financeStep";

interface IWishStep_6 {
  onChange: (data: boolean, key: TBooleanKeysOfIFillDataWizardBuy) => void;
  data: boolean | null;
  isNextStepDisabled: boolean;
  triplePrevStep: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const WishStep_6 = ({
  isNextStepDisabled,
  data,
  triplePrevStep,
  onChange,
  onReset,
}: IWishStep_6) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(
      triplePrevStep ? buySteps.wishesSteps.step_3 : buySteps.wishesSteps.step_5
    );
    onReset(["finance"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.wishesSteps.step_7);
  };

  return (
    <div>
      <FinanceStep
        onNexStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onChange={onChange}
        data={data}
        isNextStepDisabled={isNextStepDisabled}
      />
    </div>
  );
};

export default WishStep_6;
